"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vermiglio": {
    "3c78e901": [{
      "hkey": "88edb0e7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "cortina": [{
      "hkey": "88edb0e7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "vermiglio"
    }],
    "7443802f": [{
      "hkey": "88edb0e7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "pizzano": [{
      "hkey": "88edb0e7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1bb4d556": [{
      "hkey": "d5419e27",
      "slug": "vermiglio",
      "name": "Vermiglio",
      "primary": true,
      "skipSearch": false
    }],
    "stavel": [{
      "hkey": "d5419e27",
      "slug": "vermiglio",
      "name": "Vermiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2909fe8a": [{
      "hkey": "d5419e27",
      "slug": "vermiglio",
      "name": "Vermiglio",
      "primary": true,
      "skipSearch": false
    }],
    "velon": [{
      "hkey": "d5419e27",
      "slug": "vermiglio",
      "name": "Vermiglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;